import { render } from "./MonacoReadonly.vue?vue&type=template&id=b7c5692a&ts=true"
import script from "./MonacoReadonly.vue?vue&type=script&lang=ts"
export * from "./MonacoReadonly.vue?vue&type=script&lang=ts"

import "./MonacoReadonly.vue?vue&type=style&index=0&id=b7c5692a&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__